import * as React from "react";
import { useEffect, useState, useContext } from "react";
import {
  DataGrid,
  GridColumns,
  GridRowsProp,
  ptBR,
  enUS,
} from "@mui/x-data-grid";

import TextField from "@mui/material/TextField";

/*  T O O L B A R  */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";

/*  T O O L T I P  */
import Tooltip from "@mui/material/Tooltip";

/* G R I D  */
import Grid from "@mui/material/Grid";

/* C U S T O M I Z A D O  S */
import ParametroTopo from "./topo";
import ParametroPortalDataset from "../../components/data/parametroPortalDataset";
import { hasInCache } from "../../helper/cacheHelper";
import PageHelper from "../../helper/pageHelper";
import ParametroPortal from "../../components/classes/ParametroPortal";

import Button from "@mui/material/Button";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { UserContext } from "../../App";

import AutocompleteRotina from "../../components/common/AutocompleteRotina";
import RotinaDataSet from "../../components/data/RotinaDataSet";
import Rotina from "../../components/classes/Rotina";

/* INTERNACIONALIZAÇÃO */
import { useTranslation } from "react-i18next";

interface Data {
  id: number;
  rotinaId: number;
  rotinaNome: string;
  propriedade: string;
  valor: string;
}

interface AutocompletePropriedadeProps {
  valorInicial: String;
  disabled: boolean;
}

export const ParametroPortalDetalhe = () => {
  const { t, i18n } = useTranslation();
  const user: any = useContext(UserContext);
  const [nada, SetNada] = useState<ParametroPortal[]>([]);

  const [parametrosPortal, SetParametroPortal] = useState<ParametroPortal[]>(
    []
  );
  const [registro, SetRegistro] = useState<ParametroPortal>(
    () => new ParametroPortal()
  );
  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<ParametroPortal>(
    () => new ParametroPortal()
  );
  const data: ParametroPortalDataset = new ParametroPortalDataset();
  const datasetRotina: RotinaDataSet = new RotinaDataSet();

  const [codigoFornecedorSap, setCodigoFornecedorSap] = useState(0);

  const [habilita, setHabilita] = useState(false);
  const [defaultValue, SetDefaultValue] = useState("");

  const [mostraRotina, setmostraRotina] = useState(false);

  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(true);

  const [loading, setloading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [columns, setColumns] = useState<GridColumns>([]);
  const [rows, setRows] = useState<Data[]>([]);

  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);

  const dataGridTranslation = i18n.language.replace("-", "");

  function createData(
    id: number,
    rotinaId: number,
    rotinaNome: string,
    propriedade: string,
    valor: string
  ): Data {
    return {
      id,
      rotinaId,
      rotinaNome,
      propriedade,
      valor,
    };
  }

  useEffect(() => {
    setloading(true);
    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
      var _codigoFornecedorSap: number = Number(
        localStorage.getItem("CodigoFornecedorSAPSelecionado")
      );
      setCodigoFornecedorSap(_codigoFornecedorSap);
    }

    datasetRotina.Listar().then((rotinas) => {
      data.ListarAtivos().then((result) => {
        SetParametroPortal(result);
        setloading(false);
        if (result.length > 0) {
          MontaColunas();
          preencherGrid(result, rotinas);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (excluiItem === true) {
      data.Apagar(itemToExcluir).then((result) => {
        if (result) {
          //MensagemWithCustomUI(result, "Não foi possível excluir o parâmetro.");
          //   Mensagem("Aviso !",  "Não foi possível excluir o parâmetro.");
          //  }else{
          localStorage.removeItem("PropriedadeIdSel");
          setMensagem(t("pages.portalParameters.text.successExclusion"));
          setSeverity(0);
          PageHelper.refreshPage();
        }
      });
    }
    setExcluiItem(false);
    setItemExcluir(new ParametroPortal());
    setRefresh(!refresh);
  }, [excluiItem]);

  const handleClickNew = () => {
    setHabilita(true);
    setmostraRotina(true);
    SetRegistro(new ParametroPortal());
  };

  const handlerPropriedadeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, descricao: e.target.value };
    });
  };

  const handlerValorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, valorPadrao: e.target.value };
    });
  };

  const handleIncluirClick = () => {
    var parametroToAdd = new ParametroPortal();
    parametroToAdd.descricao = registro.descricao;
    parametroToAdd.valorPadrao = registro.valorPadrao;
    parametroToAdd.rotinaId = Number(localStorage.getItem("codigoRotinaSel"));
    data.Adicionar(parametroToAdd);
    // Mensagem("Aviso !", " Paramêtro Adicionado com sucesso! ");
    Mensagem(t("common.warning"), t("pages.portalParameters.text.successNew"));
    localStorage.removeItem("ParametroSel");
    handleClickNew();
    setHabilita(false);
    setmostraRotina(false);
  };

  const handleAtualizaClick = () => {
    var parametroToUpd = new ParametroPortal();
    parametroToUpd.descricao = registro.descricao;
    parametroToUpd.valorPadrao = registro.valorPadrao;
    parametroToUpd.rotinaId = registro.rotinaId;
    parametroToUpd.id = registro.id;

    data.Atualizar(parametroToUpd).then((result) => {
      console.log(result);
      if (result) {
        //MensagemWithCustomUI(result, "Não foi possível atualizar o parâmetro.");
        // Mensagem("Aviso !", "Não foi possível atualizar o parâmetro.");
        // }else{
        localStorage.removeItem("ParametroSel");
        // Mensagem("Aviso !", " Paramêtro Atualizado com sucesso! ");
        Mensagem(
          t("common.warning"),
          t("pages.portalParameters.text.successUpdate")
        );
        handleClickNew();
        setHabilita(false);
        setmostraRotina(false);
      }
    });
  };

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const MensagemWithCustomUI = (result: string, title: string) => {
    confirmAlert({
      customUI: () => (
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body">
            <h1>{title}</h1>
            {result.split("\n").map((item: string) => {
              console.log("sss");
              return <p>{item}</p>;
            })}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={() => {
                  setOpen(false);
                  setmostraRotina(false);
                  PageHelper.refreshPage();
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      setItemExcluir(
        parametrosPortal.filter((f) => f.id === cellValues.row.id)[0]
      );
      handleClickOpen();
    }
  };

  const handleSelectionChange = (id: any) => {
    if (id !== null && id !== undefined && id > 0) {
      localStorage.setItem("PropriedadeIdSel", id);
      parametrosPortal.map(function (item: ParametroPortal) {
        if (item.id === Number(id)) {
          SetDefaultValue(String(item.descricao));
          SetRegistro(item);
          setHabilita(true);
          setmostraRotina(false);
        }
      });
    } else {
      localStorage.removeItem("PropriedadeIdSel");
      setHabilita(false);
    }
  };

  function preencherGrid(_itens: ParametroPortal[], rotinas: Rotina[]) {
    setRows(
      _itens.map((_Item: ParametroPortal) => {
        let rotina = rotinas.find((x) => x.id == _Item.rotinaId);
        let nomeRotina = rotina ? rotina.nome : "";

        return createData(
          Number(_Item.id),
          Number(_Item.rotinaId),
          String(nomeRotina),
          String(_Item.descricao),
          String(_Item.valorPadrao)
        );
      })
    );
    setloading(false);
  }

  function TransitionAlerts(_severity: number, _mensagem: string) {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  }

  function MontaColunas() {
    let columns1: GridColumns = [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "propriedade",
        headerName: t("pages.portalParameters.text.parameter"),
        type: "string",
        width: 300,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "rotinaNome",
        headerName: t("pages.portalParameters.text.routine"),
        type: "string",
        flex: 1,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "valor",
        headerName: t("pages.portalParameters.text.value"),
        type: "string",
        width: 200,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "deleteico",
        width: 100,
        headerName: "",
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        align: "center",
        renderCell: () => {
          return (
            <IconButton disabled={user.isSuporte}>
              {" "}
              <EraseIcon />
            </IconButton>
          );
        },
      },
    ];
    setColumns(columns1);
  }

  return (
    <div className="container">
      <ParametroTopo />
      <div className="containerToolbar">
        <Tooltip title={t("pages.portalParameters.text.newParameter")}>
          <span>
            <IconButton onClick={handleClickNew} disabled={user.isSuporte}>
              <NewIcon />
            </IconButton>
          </span>
        </Tooltip>
        {(registro.descricao.length > 0 ||
          (localStorage.getItem("ParametroSel") !== null &&
            localStorage.getItem("ParametroSel") !== undefined)) &&
        registro.valorPadrao.length > 0 ? (
          <Tooltip title={t("pages.portalParameters.text.updateParameterData")}>
            <span>
              <IconButton
                onClick={
                  registro.id === 0 ? handleIncluirClick : handleAtualizaClick
                }
                disabled={user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
      <div className="insiderContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id={"Parametro"}
              name={"Parametro"}
              label={t("pages.portalParameters.text.parameter")}
              fullWidth
              variant="outlined"
              value={registro.descricao}
              onChange={handlerPropriedadeChange}
              sx={{ minWidth: "200px" }}
              disabled={!habilita}
            />
          </Grid>
          {mostraRotina ? (
            <Grid item xs={12} sm={6}>
              <AutocompleteRotina />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id={"Valor"}
              name={"Valor"}
              label={t("pages.portalParameters.text.value")}
              fullWidth
              variant="outlined"
              value={registro.valorPadrao}
              onChange={handlerValorChange}
              disabled={!habilita}
            />
          </Grid>
        </Grid>
        <br />
      </div>
      <div className="insiderContainer">
        <>
          <div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {t("pages.portalParameters.text.excludeItemQuestionTitle")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t("pages.portalParameters.text.excludeItemQuestionSubTitle")}
                  <br />
                  <br />
                  {t("pages.portalParameters.text.parameter")} :{" "}
                  <strong>
                    {itemToExcluir.descricao}
                    <strong />
                  </strong>
                  <br />
                  {t("pages.portalParameters.text.value")} :{" "}
                  <strong>{itemToExcluir.valorPadrao}</strong>
                  <br />
                  {t(
                    "pages.portalParameters.text.excludeItemQuestionConfirmation"
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  onClick={() => {
                    setExcluiItem(true);
                    handleClose();
                  }}
                >
                  {t("common.yes")}
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleClose}
                  autoFocus
                >
                  {t("common.no")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div style={{ height: "50vh", width: "100%" }}>
            <DataGrid
              loading={loading}
              rows={rows}
              rowsPerPageOptions={[50, 100, 250, 500]}
              columns={columns}
              experimentalFeatures={{ newEditingApi: true }}
              onSelectionModelChange={(ids) => {
                handleSelectionChange(ids);
              }}
              key="ContratoItemGrid"
              rowHeight={32}
              onCellClick={(cellValues) => {
                handleClick(cellValues);
              }}
              // checkboxSelection
              //disableSelectionOnClick
            />
            {mensagem.length > 0 ? TransitionAlerts(severity, mensagem) : null}
          </div>
        </>
      </div>
    </div>
  );
};
